// ** Reactstrap Imports
import moment from 'moment';
import { Edit2, MoreVertical, Trash2 } from 'react-feather';
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap';

const statusObj = {
  activo: 'light-success',
  inactivo: 'light-secondary'
};

const renderType = (row) => {
  const typeColor = {
    FREE: {
      primary: '#14E4ED',
      secondary: '#E8FEFF',
      text: 'Free'
    },
    PREMIUM: {
      primary: '#7139F0',
      secondary: '#EFE8FF',
      text: 'Premium'
    },
    FREEMIUM: {
      primary: '#14E4ED',
      secondary: '#FFEBF9',
      text: 'Freemium'
    },
    ALL: {
      primary: '#14E4ED',
      secondary: '#FFEBF9',
      text: 'Todos'
    },
    TEMPORAL: {
      primary: '#14E4ED',
      secondary: '#FFEBF9',
      text: 'Temporal'
    }
  };

  const Div = () => (
    <div
      style={{
        color: typeColor[row.membership].primary,
        background: `${typeColor[row.membership].secondary
          } 0% 0% no-repeat padding-box`,
        padding: '2.5px 16px',
        borderRadius: '11px',
        fontWeight: 'bold'
      }}
    >
      {typeColor[row.membership].text}
    </div>
  );

  return (
    <span className="text-left">
      <Div />
    </span>
  );
};

export const columns = ({ handleUpdate, handleDelete }) => [
  {
    name: 'FECHA',
    sortable: false,
    minWidth: '200px',
    sortField: 'date',
    selector: (row) => row.date,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">
            {moment(new Date(row.date)).format('DD/MM/YYYY, h:mm a')}
          </span>
        </div>
      </div>
    )
  },
  {
    name: 'TITULO',
    sortable: false,
    minWidth: '200px',
    sortField: 'title',
    selector: (row) => row.title,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          <span className="fw-bolder">{row.title}</span>
        </div>
      </div>
    )
  },
  {
    name: 'MENSAJE',
    minWidth: '300px',
    sortable: false,
    sortField: 'message',
    selector: (row) => row.message,
    cell: (row) => {
      const message = row.message.split(' ');

      return (
        <span className="text-capitalize" style={{ padding: '10px' }}>
          {message.length > 10
            ? `${message.slice(0, 10).join(' ')}...`
            : message}
        </span>
      );
    }
  },
  {
    name: 'MEMBRESIA',
    minWidth: '200px',
    sortable: false,
    sortField: 'membership',
    selector: (row) => row.membership,
    cell: (row) => renderType(row)
  },
  {
    name: 'ESTADO',
    minWidth: '100px',
    sortable: false,
    sortField: 'active',
    selector: (row) => row.active,
    cell: (row) => (
      <Badge
        className="text-capitalize"
        color={row.active ? statusObj.activo : statusObj.inactivo}
        pill
      >
        {row.active ? 'Activo' : 'Inactivo'}
      </Badge>
    )
  },
  {
    name: '',
    minWidth: '50px',
    cell: (row) => (
      <div className="column-action">
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="btn btn-sm">
            <MoreVertical size={14} className="cursor-pointer" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => handleUpdate({ e, row })}
            >
              <Edit2 size={14} className="me-50" />
              <span className="align-middle">Editar</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => handleDelete(row._id)}
            >
              <Trash2 size={14} className="me-50" />
              <span className="align-middle">Eliminar</span>
            </DropdownItem>
          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    )
  }
];
